import { useModelExporter } from '#imports';
import { Color, RepeatWrapping, SRGBColorSpace, Vector2 } from 'three';
import { onMounted, ref, watch } from 'vue';

import { KTXLoader } from '@resn/gozer-loading';
import { usePane } from '@resn/gozer-vue';

import { createPackSceneObjectMaterial } from '../../materials/PackSceneObjectMaterial';
import { useBaseObject } from './useBaseObject';

export const useBasketball = ({ object }) => {
    const ball = object.getObjectByName('basketball-ball');
    const outline = object.getObjectByName('basketball-outline');

    const ballMaterial = createPackSceneObjectMaterial(
        {
            color: new Color('#e2692c'),
            normalScale: new Vector2().setScalar(0.6),
            roughness: 0.6,
            metalness: 0.2,
            map: ball.material.map,
            normalMap: ball.material.normalMap,
        },
        {
            uNormalMapRepeat: { value: 5 },
        }
    );

    const outlineMaterial = createPackSceneObjectMaterial({
        color: 'black',
        roughness: 0.8,
        metalness: 0.2,
    });
    outlineMaterial.name = 'BasketballOutlineMaterial';

    ball.material = ballMaterial;
    outline.material = outlineMaterial;

    useBaseObject({ object, name: 'Basketball' });

    onMounted(() => {
        window.basketball = ball;
        window.basketballMaterial = ballMaterial;
        window.basketballOutlineMaterial = outlineMaterial;

        // loader.start();
    });

    const loader = new KTXLoader('/textures/pack/3d/dots-bump-etc1s.ktx2');
    loader.start().then((texture) => {
        texture.colorSpace = SRGBColorSpace;
        texture.wrapS = texture.wrapT = RepeatWrapping;
        texture.flipY = false;
        texture.needsUpdate = true;

        ballMaterial.bumpMap = texture;
        ballMaterial.needsUpdate = true;
    });

    return {
        ball,
        outline,
        ballMaterial,
        outlineMaterial,
    };
};
